import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { VIP_LIST, GIFT_CARDS } from "@/data/content";
export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-sage text-cream">
      {/* Slim VIP band — always visible above the main footer */}
      <div className="border-b border-cream/15 bg-sagedark/40">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 md:py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6">
          <div className="max-w-2xl">
            <p className="overline text-cream/70 mb-1.5 md:mb-2">{VIP_LIST.eyebrow}</p>
            <p className="font-serif font-light italic text-cream text-base md:text-3xl leading-snug">
              A monthly note — first look at seasonal minis, early booking access, and quiet subscriber-only offers.
            </p>
          </div>
          <a
            href={VIP_LIST.ctaHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-vip-cta"
            className="group inline-flex items-center gap-2 md:gap-3 rounded-full bg-cream text-ink px-5 py-2.5 md:px-8 md:py-4 text-xs md:text-sm font-medium hover:bg-cream/90 transition-colors duration-300 flex-shrink-0"
          >
            <Mail size={15} strokeWidth={1.8} />
            {VIP_LIST.ctaLabel}
            <ArrowUpRight
              size={15}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
        <Reveal>
          <p className="overline text-cream/70 mb-8">Ready when you are</p>
          <Link to="/contact" data-testid="footer-cta-link" className="group inline-block">
            <h2 className="font-serif font-light leading-[0.9] tracking-tight text-[8vw] md:text-[4.5vw] text-cream">
              Say hello
              <ArrowUpRight
                className="inline-block ml-2 md:ml-4 h-[4vw] w-[4vw] md:h-[3vw] md:w-[3vw] text-cream transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
                strokeWidth={1}
              />
            </h2>
          </Link>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-cream/20 pt-12">
          <div className="md:col-span-2">
            <img
              src="/logo-trim.png"
              alt="Jacqueline Claire Photography"
              className="h-20 w-auto block invert"
            />
            <p className="mt-6 max-w-sm text-cream/75 text-sm leading-relaxed">
              Acadiana photographer specializing in natural light, honest presence,
              and moments made to be kept.
            </p>
          </div>

          <div>
            <p className="overline text-cream/70 mb-4">Explore</p>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><Link to="/portfolio" className="hover:text-cream transition-colors">Portfolio</Link></li>
              <li><Link to="/investment" className="hover:text-cream transition-colors">Investment</Link></li>
              <li><Link to="/locations" className="hover:text-cream transition-colors">Locations</Link></li>
              <li>
                <Link
                  to="/studio-rental"
                  data-testid="footer-studio-link"
                  className="hover:text-cream transition-colors"
                >
                  Studio Rental
                </Link>
              </li>
              <li>
                <a
                  href={GIFT_CARDS.ctaHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-gift-cards-link"
                  className="hover:text-cream transition-colors"
                >
                  Gift Cards
                </a>
              </li>
              <li>
                <a
                  href={VIP_LIST.ctaHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-vip-link"
                  className="hover:text-cream transition-colors"
                >
                  VIP List
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="overline text-cream/70 mb-4">Connect</p>
            <ul className="space-y-2 text-sm text-cream/80">
              <li>
                <a
                  href="https://instagram.com/jacclairephotos"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-2 hover:text-cream transition-colors"
                >
                  <Instagram size={15} /> @jacclairephotos
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com/jacclairephotos"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook"
                  className="inline-flex items-center gap-2 hover:text-cream transition-colors"
                >
                  <Facebook size={15} /> Jacqueline Claire Photography
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@jacquelineclairephoto.com"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 hover:text-cream transition-colors"
                >
                  <Mail size={15} /> info@jacquelineclairephoto.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-cream/70">
          <p>© {new Date().getFullYear()} Jacqueline Claire Photography. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
